export default __webpack_public_path__ + "static/media/cabello-mujer-rubio.de75fc97.png";